<template>

<router-view />

</template>

<script>
/* eslint-disable */
export default {
  name: "App",
};
</script>